import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["details", "toggleButton"];

  connect() {
    // Ensure the button label matches initial state
    this._updateButtonText();
  }

    toggle(event) {
    event.preventDefault();
    this.detailsTarget.classList.toggle("hidden");
    this._updateButtonText();
  }

  _updateButtonText() {
    const downIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>`;
    const upIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
      </svg>`;
    if (this.detailsTarget.classList.contains("hidden")) {
      this.toggleButtonTarget.innerHTML = downIcon;
      this.toggleButtonTarget.setAttribute('aria-label', 'Expand');
    } else {
      this.toggleButtonTarget.innerHTML = upIcon;
      this.toggleButtonTarget.setAttribute('aria-label', 'Collapse');
    }
  }
}
